module.exports = __webpack_public_path__ + "static/media/chuck-norris.49005873.jpg";